import React, { useEffect, useRef, useState } from "react";
import { IconButton, InputBase, makeStyles } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import { useTranslation } from "@/langs/useTranslation";
import SingleSelector from "@/components/SingleSelector";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  count: {
    marginRight: theme.spacing(2),
    whiteSpace: "nowrap"
  },
  menu: {
    // width: 140
  },
  input: {
    width: 48,
    marginRight: 8,

    "& input": {
      border: `1px solid rgba(0, 0, 0, 0.23)`,
      height: "auto",
      borderRadius: 4,
      padding: 6,
      textAlign: "center",
      appearance: "none",

      "&:hover": {
        borderColor: "#333"
      },

      "&:focus": {
        transition: "all .2s",
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 1px ${theme.palette.primary.main} inset`
      }
    }
  },
  spliter: {
    fontSize: 20,
    marginRight: 5
  },
  pages: {
    // position: "relative",
    // top: 2
  }
}));

const Pagination = React.memo(({ table, defaultPageLength = 20 }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [pageInfo, setPageInfo] = useState({
    recordsTotal: 0,
    pages: 0,
    page: 0,
    length: defaultPageLength
  });
  const pageChanged = useRef(false);

  const pageHandler = e => {
    const pageInfo = table.current.page.info();
    if (e && e.type === "length") {
      setPageInfo({ ...pageInfo, page: 0 });
    } else {
      setPageInfo(pageInfo);
    }
  };

  const onChangeLenPerPage = e => {
    const length = +e.target.value;
    setPageInfo(prev => ({ ...prev, length }));
    table.current.page.len(length).draw();
  };

  const onBackwards = () => {
    table.current.page("previous").draw("page");
  };

  const onForwards = () => {
    table.current.page("next").draw("page");
  };

  const onPageChange = page => {
    if (page < 0) {
      page = 0;
      setPageInfo(prev => ({ ...prev, page }));
    } else if (page >= pageInfo.pages) {
      page = pageInfo.pages - 1;
      setPageInfo(prev => ({ ...prev, page }));
    }
    table.current.page(page).draw("page");
    pageChanged.current = false;
  };

  useEffect(() => {
    // table.current?.on("page", pageHandler).on("length", pageHandler);
    table.current?.on("draw", pageHandler);
    pageHandler();

    return () => {
      // table.current?.off("page", pageHandler).off("length", pageHandler);
      table.current?.off("draw", pageHandler);
    };
  }, []); // eslint-disable-line

  return (
    <div className={classes.root}>
      <span className={classes.count}>
        {t({ defaultMessage: "共{total}条" }, { total: pageInfo.recordsTotal })}
      </span>
      <SingleSelector
        className={classes.menu}
        clearable={false}
        value={pageInfo.length}
        options={[
          { id: 10, name: t({ defaultMessage: "10条/页" }) },
          { id: 20, name: t({ defaultMessage: "20条/页" }) },
          { id: 50, name: t({ defaultMessage: "50条/页" }) },
          { id: 100, name: t({ defaultMessage: "100条/页" }) },
          { id: 200, name: t({ defaultMessage: "200条/页" }) }
        ]}
        onChange={onChangeLenPerPage}
      />
      <IconButton
        onClick={onBackwards}
        disabled={pageInfo.page <= 0}
        style={{ marginRight: 3, padding: 9 }}
      >
        <ArrowBackIos fontSize="small" />
      </IconButton>
      <InputBase
        value={pageInfo.page === "" ? pageInfo.page : pageInfo.page + 1}
        className={classes.input}
        onChange={e => {
          const { value } = e.target;
          const page = value === "" ? value : (parseInt(value) || 1) - 1;
          setPageInfo(pre => ({
            ...pre,
            page
          }));
          pageChanged.current = true;
        }}
        onBlur={() => {
          if (pageChanged.current) {
            onPageChange(pageInfo.page);
          }
        }}
        onKeyDown={e => {
          if (e.keyCode === 13) {
            onPageChange(pageInfo.page);
          }
        }}
      />
      <span className={classes.spliter}>/</span>
      <span className={classes.pages}>{pageInfo.pages || 1}</span>
      <IconButton
        onClick={onForwards}
        disabled={pageInfo.page >= pageInfo.pages - 1}
        style={{ marginLeft: 3, padding: 9 }}
      >
        <ArrowForwardIos fontSize="small" />
      </IconButton>
    </div>
  );
});

export default Pagination;
